import { TemplateElement, defineElement, html } from '@webtides/element-js';
import { classMap, when } from '@webtides/element-js/src/dom-parts/directives';
import style from './e-banking-notification.css';
import { responsiveImage } from '../../../../directives/images.js';

/**
 * @property {string} variant
 * @property {string} title
 * @property {string} text
 * @property {string} iconPosition
 * @property {ImageProperties} icon
 */

export default class Notification extends TemplateElement {
    constructor() {
        super({ styles: [style] });
    }

    properties() {
        return {
            variant: 'default', // 'promotion'
            title: '',
            text: '',
            iconPosition:'top', //center
            icon: {},
        };
    }

    template() {
        const colors = {
            'bg-[#EFF2F1]': this.variant === 'default',
            'bg-[#FFF8E7] border border-solid !border-[#FFDF8C]': this.variant === 'promotion',
        };
        const size = {
            'text-base': this.variant === 'default',
            'text-sm': this.variant === 'promotion',
        };
        const position = {
            'self-center': this.iconPosition === 'center',
            'self-start': this.iconPosition === 'top',
        };
        return html`
            <div class="flex p-16 rounded ${classMap(colors)}">
                <div class="${classMap(position)} mr-16 shrink-0">
                    ${responsiveImage(
                        this.icon,
                        'max-w-40',
                        false
                    )}
                </div>
                <div>
                    <h2 class="${classMap(size)} font-medium mb-2 leading-none">${this.title}</h2>
                    <p class="text-sm mb-0">${this.text}</p>
                </div>
            </div>
        `;
    }
}

defineElement('mb-e-banking-notification', Notification);
